export enum TranslatableIntendedUsageType {
  REALTIME = 'LOCATIONS.INTENDEDUSAGETYPES.REALTIME',
  ANALYTICS = 'LOCATIONS.INTENDEDUSAGETYPES.ANALYTICS',
  CONTRACT_REALTIME = 'LOCATIONS.INTENDEDUSAGETYPES.CONTRACT_REALTIME',
  CONTRACT_ANALYTICS = 'LOCATIONS.INTENDEDUSAGETYPES.CONTRACT_ANALYTICS'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/translatable-intended-usage-type.ts